import React from 'react';
import { Link } from 'react-router-dom';
import img from './images/logo.png'
import "./logo.css"



const logo = () => {
    return (
        <Link to="/" className="logo"><img src={img} alt="Failed" /></Link>
    );
};

export default logo;